<div class="entity-search">
  <ng-container *ngIf="(filteredEntities$ | async) as filteredEntities">
    <nv-textbox-virtual-scroll
      (clearValue)="clearSearch()"
      (selectOption)="goToEntity($event)"
      [autocompleteOptions]="filteredEntities"
      [textControl]="entitySearchControl"
      hasClearBtn="true"
      returnObject="true"
      emptyStateText="{{ emptyStateText }}"
      placeholder="{{ placeholder }}"
      [customViewportHeight]="menuHeight"
      [customStylingWrapperId]="customStylingWrapperId"
      [autocompleteHasActiveState]="autocompleteHasActiveState"
      [hasAutoActiveFirstOption]="false"
      [isDisabled]="isDisabled"
      [icon]="icon"
      [isInverted]="isInverted"
      [roundedCorner]="roundedCorner"
    ></nv-textbox-virtual-scroll>
  </ng-container>
</div>
